
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgButtonIconR = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 22,
  viewBox: "0 0 16 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.231 1.269a2.625 2.625 0 0 0-3.866 3.545l.154.167L7.537 11l-6.018 6.019a2.624 2.624 0 0 0-.154 3.545l.154.167a2.625 2.625 0 0 0 3.545.153l.167-.153L14.962 11 5.231 1.269z",
  fill: "var(--theme-primary, #810ea9)",
  fillRule: "nonzero"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"22\" viewBox=\"0 0 16 22\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g fill=\"var(--theme-primary, #810ea9)\" fill-rule=\"nonzero\">\r\n            <g>\r\n                <g>\r\n                    <path d=\"M9.731.769c1.025-1.025 2.687-1.025 3.712 0 .972.971 1.023 2.514.154 3.545l-.154.167L7.425 10.5l6.018 6.019c.972.971 1.023 2.514.154 3.545l-.154.167c-.97.971-2.514 1.022-3.545.153l-.167-.153L0 10.5 9.731.769z\" transform=\"translate(-1386 -1012) translate(39 1012) translate(1347) matrix(-1 0 0 1 14.962 .5)\"/>\r\n                </g>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/button-icon-r.e8743d3b795e17fb784e8abd64cb3e00.svg"),
        {
          React: SvgButtonIconR,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      